import { NgModule } from '@angular/core';

import { GlowAuthService } from '../services/glowadminservices/glowauth.service';

import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { GenerateResetPasswordTokenComponent } from './generate-reset-password-token/generate-reset-password-token.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [
        GenerateResetPasswordTokenComponent,
        LoginComponent,        
        ResetPasswordComponent
    ],
    imports: [
        SharedModule
    ],
    exports: [
        GenerateResetPasswordTokenComponent,
        LoginComponent,        
        ResetPasswordComponent
    ],
    providers: [
        GlowAuthService
    ]
})
export class PublicPagesModule {
}
